module.exports = __webpack_public_path__ + "0befc303bccfaced18fb7631eb2024a2.svg";